import { Component } from '@angular/core';  
import { AppSettings } from 'fg-library';

@Component({
    selector: 'fg-client-app-auth-layout',
    templateUrl: './auth-layout.component.html',
    standalone: false
})
export class FgClientAuthLayoutComponent {
    public currentTheme: string = "";
    public logoDescription: any;

    constructor() {
        this.logoDescription = AppSettings.logoDescription;
    }

}
